export default __webpack_public_path__ + "static/media/HowItWorks-05.58bfe8af.jpg";